const state = {
  savedForms: []
};

const mutations = {
  SET_SAVED_FORMS(state, forms) {
    state.savedForms = forms;
  },
  ADD_OR_UPDATE_FORM(state, form) {
    const index = state.savedForms.findIndex(existingForm => existingForm.id === form.id);
    if (index !== -1) {
      // Обновляем существующую форму
      state.savedForms.splice(index, 1, form);
    } else {
      // Добавляем новую форму
      state.savedForms.push(form);
    }
  },
  DELETE_FORM(state, formId) {
    state.savedForms = state.savedForms.filter(form => form.id !== formId);
  }
};

const actions = {
  clearSavedForms({ commit }) {
    commit('SET_SAVED_FORMS', []); // Используем SET_SAVED_FORMS для очистки
    localStorage.removeItem('savedForms'); // Очистка localStorage
  },
  loadSavedForms({ commit }) {
    const forms = JSON.parse(localStorage.getItem('savedForms')) || [];
    commit('SET_SAVED_FORMS', forms);
  },
  saveForm({ commit, state }, form) {
    commit('ADD_OR_UPDATE_FORM', form);
    localStorage.setItem('savedForms', JSON.stringify(state.savedForms));
  },
  deleteForm({ commit, state }, formId) {
    commit('DELETE_FORM', formId);
    localStorage.setItem('savedForms', JSON.stringify(state.savedForms));
  }
};

const getters = {
  hasSavedForms(state) {
    return state.savedForms.length > 0; // Проверяем, есть ли хотя бы одна сохраненная форма
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

